import { render } from "./PotentialPolicyTable.vue?vue&type=template&id=d787cb82&scoped=true"
import script from "./PotentialPolicyTable.vue?vue&type=script&lang=js"
export * from "./PotentialPolicyTable.vue?vue&type=script&lang=js"

import "./PotentialPolicyTable.vue?vue&type=style&index=0&id=d787cb82&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d787cb82"]])

export default __exports__